export const APPEARANCE_DURATION = 500;
export const MOBILE_MEDIA_QUERY = `(max-width: 600px)`;

export const defaultVideoModelData = {
  loaded: false,
  expanded: false,
  muted: true,
  onceStarted: false
};

export const ActionType = {
  LOAD: `load`,
  EXPAND: `expand`,
  COLLAPSE: `collapse`,
  MUTE: `mute`,
  UNMUTE: `unmute`,
  CHANGE_TIME: `change_time`,
  DESTROY: `destroy`,
  ONCE_STARTED: `once_started`
};

export const YM_COUNTER_ID = 29276100;
export const YM_STORAGE_PREFIX = `ym_goal_`;
export const WATCH_GOAL_SECONDS = 60;
